import moment from 'moment-es6';

export const old_date = {
  validate: (value, options) => {
    const offset = options[0];

    let formattedValue = moment(value).toDate();
    let inputTimestamp = formattedValue.getTime();

    const currentDate = new Date();
    let currentTimestamp = currentDate.getTime();

    let currentTz = new Date().getTimezoneOffset() * 1000 * 60;
    let diff = currentTz - offset * 60 * -1000;
    let result = currentTimestamp + diff;

    return inputTimestamp > result;
  }
};
